module.exports = __webpack_public_path__ + "img/Girl_010014.3d6aaa24.png";